<template>
    <div class="left side-menu clearfix position-fixed">
        <div id="remove-scroll" class="slimscroll-menu">
            <div id="sidebar-menu">
                <ul id="side-menu" class="metismenu">
                    <slidebar-item v-for="(item,index) in slideMenuItems" :key="index" :data="item" :type="item.type"
                                   :icon="item.icon" :name="item.name" :router="item.router" :active="isActive(item)"/>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    import SlidebarItem from "@/components/SlidebarItem";

    export default {
        name: "SideBar",
        components: {SlidebarItem},
        props: {
            slideMenuItems: {
                type: Array,
                default: []
            }
        },

        methods: {
            isActive: function (item) {
                return (item.router.name == this.$store.state.sidebar) ? 'active' : ''
            }
        }
    }
</script>

<style scoped>

</style>